import { createMuiTheme } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import { defaultsDeep, get } from 'lodash';

import getThemePropsDefault from './getThemePropsDefault';

const fontFamily = '"freight-sans-pro",sans-serif';
const primaryMain = '#182538';
const secondaryMain = '#f37021';

const placeholder = {
  color: 'initial',
};

const getThemePropsLuma = (defaultProps, theme = createMuiTheme(getThemePropsDefault())) =>
  defaultsDeep(
    {},
    {
      themeName: 'Luma Theme',
      typography: {
        fontFamily,
      },
      palette: {
        primary: {
          main: primaryMain,
        },
        secondary: {
          main: secondaryMain,
        },
        tertiary: theme.palette.augmentColor({
          main: primaryMain,
        }),
        background: {
          default: '#F0F6F7',
          ...(get(defaultProps, 'palette.type') === 'dark' && { paper: primaryMain }),
        },
      },
      mixins: {
        toolbar: {
          minHeight: theme.spacing.unit * 8,
          [theme.breakpoints.up('sm')]: {
            minHeight: theme.spacing.unit * 10,
          },
        },
      },
      overrides: {
        MuiInput: {
          input: {
            color: primaryMain,
            '&::-webkit-input-placeholder': placeholder,
            '&::-moz-placeholder': placeholder, // Firefox 19+
            '&:-ms-input-placeholder': placeholder, // IE 11
            '&::-ms-input-placeholder': placeholder, // Edge
          },
        },
        MuiFormLabel: {
          root: {
            color: 'rgba(0, 0, 0, 0.3)',
          },
        },
        MuiButton: {
          containedSecondary: {
            color: theme.palette.common.white,
          },
        },
        // Luma components
        LumaHeader: {
          root: {
            backgroundColor: theme.palette.common.white,
          },
          logo: {
            maxWidth: 328,
            maxHeight: 48,
            [theme.breakpoints.down('xs')]: {
              maxWidth: 185,
              maxHeight: 42,
            },
          },
        },
        LumaDialogTitle: {
          root: {
            background: primaryMain,
            color: theme.palette.common.white,
            '& > h6': {
              color: 'inherit',
            },
          },
        },
        LumaDialogContent: {
          root: {
            paddingTop: theme.spacing.unit * 4,
          },
        },
        LumaDialogActions: {
          root: {
            margin: 0,
            padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px`,
            backgroundColor: grey[200],
          },
          action: {
            minWidth: 120,
          },
        },
        LumaFeedbackPage: {
          root: {
            background: '#cde7ed',
          },
        },
        LumaRemindersReplyPage: {
          root: {
            background: '#cde7ed',
          },
        },
        LumaVerifyUserPage: {
          submitButton: {
            backgroundColor: secondaryMain,
          },
        },
        LumaSignupPage: {
          submitButton: {
            backgroundColor: secondaryMain,
          },
        },
        LumaButton: {
          label: {
            textTransform: 'none',
          },
        },
      },
      props: {
        LumaApp: {
          pageTitle: 'Patient App',
          favicon: './favicon-luma.ico',
        },
        LumaHeader: {
          logoSrc: 'https://lumahealth-assets.s3-us-west-2.amazonaws.com/patientapp-logo.png',
        },
      },
    },
    defaultProps,
  );

export default getThemePropsLuma;
